export const FRESHSTART_PROMOCODE = 'FRESHSTART'
export const WELCOME5_PROMOCODE = 'WELCOME5'
export const BILL_LINKING_PROMO_TYPE = 'bill_linking'
export const PROMOCODE_STATUSES = {
  EARNED: 'earned',
  REDEEMED: 'redeemed',
  PENDING: 'pending'
}
